import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/characters", label: "角色详解" },
  { to: "/relationships", label: "人物关系" },
  { to: "/faq", label: "常见问题" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-background-50/0"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] max-w-6xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5 group">
          <span className="grid h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base md:text-lg font-bold text-foreground-950">
              继母与继姐·人物图鉴
            </span>
            <span className="mt-1 text-[11px] tracking-widest text-foreground-500">
              角色 · 关系 · 设定
            </span>
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => {
            const active = item.to === "/" ? pathname === "/" : pathname.startsWith(item.to);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`whitespace-nowrap rounded-md px-4 py-2 text-sm transition-colors ${
                  active
                    ? "bg-primary-100 text-primary-700 font-medium"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
          <Link
            to="/characters"
            className="ml-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始阅读角色
          </Link>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="grid h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-900 md:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          {navItems.map((item) => {
            const active = item.to === "/" ? pathname === "/" : pathname.startsWith(item.to);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`mb-1 block rounded-md px-3 py-3 text-sm ${
                  active
                    ? "bg-primary-100 font-medium text-primary-700"
                    : "text-foreground-700"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
          <Link
            to="/characters"
            className="mt-1 block rounded-md bg-primary-500 px-3 py-3 text-center text-sm font-medium text-background-50"
          >
            开始阅读角色
          </Link>
        </div>
      )}
    </header>
  );
}